function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.876 17.322c-.689.43-1.504.678-2.376.678-2.485 0-4.5-2.015-4.5-4.5S10.015 9 12.5 9s4.5 2.015 4.5 4.5c0 .883-.254 1.706-.693 2.401l3.084 3.083-1.407 1.406-3.108-3.068zM12.5 11c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5-1.119-2.5-2.5-2.5zM0 16V2C0 .89.89 0 2 0h14c1.11 0 2 .89 2 2v8.034c-.511-.808-1.195-1.497-2-2.012V2H2v14h4.498c.312.747.759 1.424 1.311 2H2c-1.11 0-2-.89-2-2zm4-2v-2h2.174c-.114.481-.174.984-.174 1.5l.019.5H4zM4 4h10v2H4V4zm3.022 6H4V8h5.034c-.809.511-1.497 1.195-2.012 2z"
});

var SvgFileDocumentBoxSearch = function SvgFileDocumentBoxSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileDocumentBoxSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-document-box-search.41ec4d56.svg";
export { ForwardRef as ReactComponent };